<template>
  <div id="app">
    <router-view v-if="!$route.meta.keepAlive "></router-view>
    <el-container v-if="$route.meta.keepAlive && isRouterAlive ">
      <el-header>
        <keep-alive>
          <v-header :type="type"
                    :custDateTimeStr="custDateTimeStr"
                    :menuList="menuList"></v-header>
        </keep-alive>
      </el-header>
      <el-container>
        <el-aside :width="leftWidth">
          <keep-alive>
            <v-menu-new @updateLeftWdith="onLeftWidth"
                        :menuList="menuList"
                        :pers="pers"
                        :type="type"
                        @refreshLeft="refreshLeft"></v-menu-new>
            <!-- <v-menu @updateLeftWdith="onLeftWidth"
                    :menuList="menuList"
                    :type="type"
                    @refreshLeft="refreshLeft"></v-menu> -->
          </keep-alive>
        </el-aside>
        <el-main>
          <router-view :menuList="menuList"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import top from './view/home/top'
import leftNew from './view/home/leftGroup'
// import left from './view/home/left'
import * as user from './api/user'
export default {
  data () {
    return {
      is_admin: false,
      leftWidth: '',
      isRouterAlive: true,
      menuList: [],
      pers: {
        isShowDevice: false,
        isShowCust: false,
        isShowAliPark: false,
        isShowParkingGuidance: false,
        isShowRoadPark: false,
        isShowAdTemp: false,
        isShowPark: false,
        isShowCard: false,
        isShowRate: false,
        isShowCoupon: false,
        isShowRoadData: false,
        isShowTJTHCData: false,
        isShowBGGCData: false,
        isShowXHLData: false,
        isShowHSDSData: false,
        isShowBJXCData: false,
        isShowYangZiJiangData: false,
        isShowGungaAirData: false,
        isShowHongKongPlazaData: false,
        isShowZhaBeiPlazaData: false,
        isShowFudanData: false,
        isShowFinanceData: false,
        isShowBusinessData: false,
        isShowZHReportData: false,
        isShowFuDanEhallCardData: false,
        isShowCustCardSetUserData: false,
        isShowCustomizedCard: false

      },
      type: '',
      custDateTimeStr: ''
    }
  },
  components: {
    'v-header': top,
    // 'v-menu': left,
    'v-menu-new': leftNew
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  created () {

  },
  mounted () {
    this.leftWidth = '280px'
  },
  methods: {
    onLeftWidth (width) {
      this.leftWidth = width
    },
    refreshLeft () {
      user.getCurrentUserPers({ perTypeId: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.is_admin = data.Data.is_admin
              var menuList = data.Data.data || []
              this.menuList = menuList
              this.type = data.Data.type
              this.pers.isShowDevice = (menuList.indexOf(70010) > -1 || menuList.indexOf(74010) > -1 || menuList.indexOf(71010) > -1 || menuList.indexOf(72010) > -1 || menuList.indexOf(73010) > -1 || menuList.indexOf(75010) > -1 || menuList.indexOf(76010) > -1 || menuList.indexOf(70110) > -1 || menuList.indexOf(77010) > -1 || menuList.indexOf(78010) > -1 || menuList.indexOf(79010) > -1 || menuList.indexOf(1060010) > -1)
              this.pers.isShowCust = (menuList.indexOf(40010) > -1 || menuList.indexOf(41010) > -1 || menuList.indexOf(42010) > -1 || menuList.indexOf(43010) > -1 || menuList.indexOf(210010) > -1 || menuList.indexOf(340010) > -1 || menuList.indexOf(240010) > -1)
              this.pers.isShowAliPark = (menuList.indexOf(90010) > -1 || menuList.indexOf(90110) > -1)
              this.pers.isShowParkingGuidance = (menuList.indexOf(26610) > -1)
              this.pers.isShowRoadPark = ((this.type === '1' || this.type === '2') && (menuList.indexOf(80010) > -1 || menuList.indexOf(81010) > -1 || menuList.indexOf(82010) > -1 || menuList.indexOf(83010) > -1 || menuList.indexOf(84010) > -1 || menuList.indexOf(250010) > -1))
              this.pers.isShowAdTemp = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1000010) > -1 || menuList.indexOf(1001010) > -1))
              this.pers.isShowPark = ((this.type === '0' || this.type === '2') && (menuList.indexOf(21010) > -1 || menuList.indexOf(22010) > -1 || menuList.indexOf(1199010) > -1 || menuList.indexOf(1283010) > -1 || menuList.indexOf(23010) > -1 || menuList.indexOf(24010) > -1 || menuList.indexOf(25010) > -1 || menuList.indexOf(26010) > -1 || menuList.indexOf(26110) > -1 || menuList.indexOf(26210) > -1 || menuList.indexOf(26310) > -1 || menuList.indexOf(26510) > -1))
              this.pers.isShowCard = (menuList.indexOf(31010) > -1 || menuList.indexOf(30010) > -1 || menuList.indexOf(900010) > -1 || menuList.indexOf(33010) > -1 || menuList.indexOf(32010) > -1 || menuList.indexOf(35010) > -1 || menuList.indexOf(36010) > -1)
              this.pers.isShowRate = (menuList.indexOf(50010) > -1 || menuList.indexOf(51010) > -1 || menuList.indexOf(52010) > -1)
              this.pers.isShowCoupon = ((this.type === '0' || this.type === '2') && (menuList.indexOf(180010) > -1 || menuList.indexOf(190010) > -1 || menuList.indexOf(191010) > -1 || menuList.indexOf(200010) > -1 || menuList.indexOf(201010) > -1 || menuList.indexOf(172010) > -1 || menuList.indexOf(1019010) > -1 || menuList.indexOf(26410) > -1))
              this.pers.isShowRoadData = ((this.type === '1' || this.type === '2') && (menuList.indexOf(110010) > -1 || menuList.indexOf(120010) > -1 || menuList.indexOf(130010) > -1 || menuList.indexOf(140010) > -1 || menuList.indexOf(150010) > -1 || menuList.indexOf(160010) > -1 || menuList.indexOf(170010) > -1 || menuList.indexOf(270010) > -1 || menuList.indexOf(171010) > -1 || menuList.indexOf(260010) > -1))
              this.pers.isShowTJTHCData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1021010) > -1 || menuList.indexOf(1022010) > -1 || menuList.indexOf(1023010) > -1 || menuList.indexOf(1024010) > -1 || menuList.indexOf(1025010) > -1 || menuList.indexOf(1026010) > -1))
              this.pers.isShowBGGCData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1031010) > -1 || menuList.indexOf(1032010) > -1 || menuList.indexOf(1033010) > -1 || menuList.indexOf(1034010) > -1 || menuList.indexOf(1035010) > -1 || menuList.indexOf(1036010) > -1 || menuList.indexOf(1037010) > -1 || menuList.indexOf(1058010) > -1 || menuList.indexOf(1059010) > -1 || menuList.indexOf(1055010) > -1 || menuList.indexOf(1056010) > -1 || menuList.indexOf(1057010) > -1))
              this.pers.isShowXHLData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1131010) > -1 || menuList.indexOf(1132010) > -1 || menuList.indexOf(1133010) > -1 || menuList.indexOf(1135010) > -1 || menuList.indexOf(1136010) > -1 || menuList.indexOf(1137010) > -1 || menuList.indexOf(1158010) > -1 || menuList.indexOf(1159010) > -1 || menuList.indexOf(1155010) > -1 || menuList.indexOf(1156010) > -1))
              this.pers.isShowHSDSData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1157010) > -1 || menuList.indexOf(1160010) > -1))
              this.pers.isShowBJXCData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1161010) > -1))
              this.pers.isShowYangZiJiangData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1011010) > -1 || menuList.indexOf(1012010) > -1 || menuList.indexOf(1013010) > -1 || menuList.indexOf(1014010) > -1 || menuList.indexOf(1015010) > -1 || menuList.indexOf(1016010) > -1 || menuList.indexOf(1017010) > -1 || menuList.indexOf(1018010) > -1))
              this.pers.isShowGungaAirData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1002010) > -1 || menuList.indexOf(1003010) > -1 || menuList.indexOf(1004010) > -1 || menuList.indexOf(1005010) > -1 || menuList.indexOf(1006010) > -1 || menuList.indexOf(1007010) > -1 || menuList.indexOf(1008010) > -1 || menuList.indexOf(1009010) > -1 || menuList.indexOf(1008110) > -1))
              this.pers.isShowHongKongPlazaData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(880010) > -1 || menuList.indexOf(881010) > -1 || menuList.indexOf(882010) > -1 || menuList.indexOf(883010) > -1 || menuList.indexOf(884010) > -1 || menuList.indexOf(886010) > -1 || menuList.indexOf(887010) > -1))
              this.pers.isShowZhaBeiPlazaData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1190010) > -1 || menuList.indexOf(1191010) > -1 || menuList.indexOf(1192010) > -1 || menuList.indexOf(1193010) > -1 || menuList.indexOf(1194010) > -1 || menuList.indexOf(1196010) > -1 || menuList.indexOf(1197010) > -1))
              this.pers.isShowFudanData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(69610) > -1 || menuList.indexOf(69810) > -1 || menuList.indexOf(69910) > -1 || menuList.indexOf(300010) > -1 || menuList.indexOf(310010) > -1 || menuList.indexOf(1040010) > -1 || menuList.indexOf(1041010) > -1))
              this.pers.isShowFinanceData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(67010) > -1 || menuList.indexOf(66010) > -1 || menuList.indexOf(67110) > -1 || menuList.indexOf(68210) > -1 || menuList.indexOf(68510) > -1 || menuList.indexOf(68010) > -1 || menuList.indexOf(68110) > -1 || menuList.indexOf(69510) > -1 || menuList.indexOf(69110) > -1 || menuList.indexOf(69710) > -1 || menuList.indexOf(1010010) > -1 || menuList.indexOf(1020010) > -1 || menuList.indexOf(1180010) > -1 || menuList.indexOf(1198010) > -1 || menuList.indexOf(1181010) > -1 || menuList.indexOf(682010) > -1))
              this.pers.isShowBusinessData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(60010) > -1 || menuList.indexOf(61010) > -1 || menuList.indexOf(68410) > -1 || menuList.indexOf(62010) > -1 || menuList.indexOf(63010) > -1 || menuList.indexOf(64010) > -1 || menuList.indexOf(65010) > -1 || menuList.indexOf(69210) > -1 || menuList.indexOf(1050010) > -1 || menuList.indexOf(69090) > -1 || menuList.indexOf(69310) > -1 || menuList.indexOf(69410) > -1 || menuList.indexOf(1027010) > -1 || menuList.indexOf(1170010) > -1 || menuList.indexOf(1100010) > -1 || menuList.indexOf(1120010) > -1 || menuList.indexOf(600010) > -1 || menuList.indexOf(610010) > -1 || menuList.indexOf(1042010) > -1 || menuList.indexOf(1043010) > -1 || menuList.indexOf(1044010) > -1))
              this.pers.isShowZHReportData = ((this.type === '0' || this.type === '2') && (menuList.indexOf(1280010) > -1 || menuList.indexOf(1281010) > -1 || menuList.indexOf(1282010) > -1))
              this.pers.isShowFuDanEhallCardData = (menuList.indexOf(1039010) > -1 || menuList.indexOf(1039020) > -1 || menuList.indexOf(1039110) > -1 || menuList.indexOf(26710) > -1 || menuList.indexOf(1039410) > -1)
              this.pers.isShowCustCardSetUserData = (menuList.indexOf(1039210) > -1)
              this.pers.isShowCustomizedCard = (menuList.indexOf(1039310) > -1)
              this.custDateTimeStr = data.Data.custDateTimeStr
            }
          } else {
            this.$message.error('提示：加载当前用户权限信息失败')
          }
        }
      })
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style scoped>
.leftWidth {
  width: 280px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue